import { IonContent, IonImg } from "@ionic/react";
// @ts-ignore
//import ReactCountdownClock from "react-countdown-clock";
import { useEffect, useState } from "react";

interface Props {
  setGaitAssessmentCounter: Function;
}

const GaitAssessmentCounterModal: React.FC<Props> = ({
  setGaitAssessmentCounter,
}) => {
  const assessment = sessionStorage.getItem("selectedAssesment");

  return (
    <IonContent placeholder={undefined}>
      <div className="assessmet-complete-wrap counter-center-sec">
        <div className="assessmnet-text-wrap">
          <h2>Go!</h2>
          {assessment === "31" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="401"
              height="400"
              viewBox="0 0 401 400"
              fill="none"
            >
              <path
                d="M200.5 0C310.957 0 400.5 89.543 400.5 200C400.5 310.457 310.957 400 200.5 400C90.043 400 0.5 310.457 0.5 200C0.500003 89.543 90.043 3.10884e-06 200.5 0Z"
                fill="#0F854C"
              />
              <path
                d="M70.6865 146.18C74.612 145.296 78.5114 147.761 79.3955 151.687L94.6738 219.521H129.912C133.936 219.521 137.197 222.783 137.197 226.807C137.197 230.83 133.936 234.092 129.912 234.092H129.825L137.01 265.59C137.904 269.513 135.449 273.419 131.526 274.313C127.603 275.208 123.697 272.753 122.803 268.83L114.88 234.092H102.54L94.6172 268.83C93.7224 272.753 89.8167 275.208 85.8936 274.313C81.9706 273.419 79.5154 269.513 80.4102 265.59L87.6182 233.987C84.7492 233.498 82.3952 231.324 81.7383 228.407L65.1797 154.888C64.2958 150.962 66.7611 147.064 70.6865 146.18Z"
                fill="white"
              />
              <ellipse
                cx="278.265"
                cy="122.831"
                rx="18.8349"
                ry="17.8309"
                fill="white"
              />
              <path
                d="M247.695 219.717C248.683 221.015 249.899 222.191 251.335 223.186L264.407 232.236L244.666 288.146C242.909 293.121 237.241 295.778 232.006 294.079C226.771 292.38 223.951 286.968 225.708 281.992L247.695 219.717ZM259.64 145.672L283.011 147.569C286.99 147.892 289.925 151.378 289.564 155.354L289.473 156.366C295.009 165.11 308.648 178.905 330.689 181.09C334.483 181.466 337.235 184.682 336.838 188.273C336.441 191.865 333.043 194.471 329.25 194.095C310.734 192.259 296.982 183.962 287.764 175.231L284.002 216.746L302.83 229.606C305.471 231.41 307.024 234.315 306.997 237.397L306.582 284.804C306.536 290.055 302.002 294.278 296.454 294.234C290.907 294.191 286.446 289.897 286.492 284.646L286.864 242.154L255.417 220.674C255.321 220.608 255.228 220.539 255.135 220.471L254.482 220.418C251.829 220.202 249.873 217.878 250.113 215.228L254.822 163.232C245.84 169.495 234.923 181.175 232.537 198.677C232.049 202.258 228.586 204.786 224.804 204.324C221.021 203.862 218.351 200.584 218.839 197.003C222.762 168.229 244.861 152.09 256.775 146.977C257.422 146.108 258.486 145.578 259.64 145.672Z"
                fill="white"
              />
              <path
                d="M161.197 202.5C159.817 202.5 158.697 203.619 158.697 205C158.697 206.381 159.817 207.5 161.197 207.5V205V202.5ZM196.549 206.768C197.525 205.791 197.525 204.209 196.549 203.232L180.639 187.322C179.663 186.346 178.08 186.346 177.104 187.322C176.127 188.299 176.127 189.882 177.104 190.858L191.246 205L177.104 219.142C176.127 220.118 176.127 221.701 177.104 222.678C178.08 223.654 179.663 223.654 180.639 222.678L196.549 206.768ZM161.197 205V207.5H194.781V205V202.5H161.197V205Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="279"
              height="279"
              viewBox="0 0 279 279"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M139.499 0.503662C62.7332 0.503662 0.502441 62.7345 0.502441 139.5C0.502441 216.266 62.7332 278.496 139.499 278.496C216.264 278.496 278.495 216.266 278.495 139.5C278.495 62.7345 216.264 0.503662 139.499 0.503662Z"
                fill="#43BA73"
              />
              <path
                d="M154.579 92.2791C162.356 92.2791 168.718 85.9163 168.718 78.1395C168.718 70.3628 162.356 64 154.579 64C146.802 64 140.439 70.3628 140.439 78.1395C140.439 85.9163 146.802 92.2791 154.579 92.2791ZM128.421 116.316L110.322 207.587C109.403 211.9 112.797 216 117.251 216H117.816C121.139 216 123.967 213.738 124.745 210.486L136.198 159.442L151.044 173.581V208.93C151.044 212.819 154.225 216 158.114 216C162.002 216 165.184 212.819 165.184 208.93V169.057C165.184 165.168 163.628 161.492 160.8 158.806L150.337 148.837L154.579 127.628C162.144 136.394 173.102 142.687 185.403 144.666C189.645 145.302 193.463 141.909 193.463 137.596C193.463 134.132 190.918 131.233 187.453 130.668C176.707 128.9 167.799 122.538 163.063 114.195L155.993 102.884C152.034 96.5916 144.116 94.0465 137.258 96.9451L110.181 108.398C104.949 110.66 101.556 115.751 101.556 121.477V138.233C101.556 142.121 104.737 145.302 108.625 145.302C112.514 145.302 115.695 142.121 115.695 138.233V121.265L128.421 116.316Z"
                fill="#FDFDFD"
              />
            </svg>
          )}
        </div>
      </div>
    </IonContent>
  );
};
export default GaitAssessmentCounterModal;
